(function(){
'use strict';

createCapi.$inject = ["$q", "scAnalyticsUtils", "$http"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createCapi($q, scAnalyticsUtils, $http) {
  var _this = this;

  var capiService = { name: 'meta_capi' };

  /* Interface Methods
  ========================================================= */
  capiService.registerSuperProperties = function () {};
  capiService.identifyMember = function () {};
  capiService.eventBeacon = function () {};

  var trackedEvents = ['fundraising-page/create/complete', 'donation/create/begin', 'donation/create/complete', 'registration/create/begin', 'registration/create/complete', 'recurring-donation/create/complete'];

  capiService.loaded = function () {
    return $q(function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!getPixelId()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', resolve());

              case 4:
                return _context.abrupt('return', reject());

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  capiService.recordPageView = function (data) {
    if (getPixelId()) {
      var serverData = scAnalyticsUtils.buildChannelEventObject('ViewContent', data);
      capiService.sendEvent(serverData);
    }
  };

  capiService.track = function (event, data) {
    if (getPixelId()) {
      if (!_.includes(trackedEvents, event)) return;
      var serverData = scAnalyticsUtils.buildChannelEventObject(event, data);
      capiService.sendEvent(serverData);
    }
  };

  capiService.sendEvent = function (obj) {
    var organizationId = SC.organization.id;
    try {
      $http({
        method: 'POST',
        url: '/frs-api/organizations/' + organizationId + '/channel-events',
        data: obj
      });
    } catch (e) {}
  };

  return capiService;

  /* Private Methods
  =========================================================
  */

  function getPixelId() {
    var metaCapiStateObj = _.get(SC.organization, 'metaCapiChannel');
    return _.get(metaCapiStateObj, 'pixelID', null);
  }
}

angular.module('classy').factory('capiService', createCapi);
})();